import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, RentalStockStatusOptions, StatusCodeActive } from "utils/Constant";
import { ApiGetCompanyList, ApiDeleteCompany } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";

export default function Client(){
    let navigate = useNavigate()
    const {openModal, closeModal} = useModal()
    
    const { fetch: apiGetCompanyList, data: companyList } = useFetch(ApiGetCompanyList)
    const { fetch: apiDeleteCompany } = useFetch(ApiDeleteCompany)

    const [companyName, setCompanyName] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [firstLoad, setFirstLaod] = useState(true)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Button Event
    const addBtnClick = () => {
        navigate("/client/form?companyId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/client/form?companyId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                deleteCompany(id, status).then((res) => {
                    if (checkResponse(res)) {
                        fBindGrid(pageIndex)
                        closeModal()
                    }                    
                })
            },
        })
    }

    // API Calls
    const getCompanyList = async(index) => {
        let res = await apiGetCompanyList({
            data: {
                companyName, 
                status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        })

        return res
    }
    const deleteCompany = async(companyId, status) => {
        let res

        res = await apiDeleteCompany({
            data: {
                companyId,
                status
            }
        })

        return res
    }

    // Function Grid
    async function fBindGrid(index){
        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        getCompanyList(i).then((res) => {
            if (checkResponse(res)) {
                if (res !== null){
                    let totalData = res.data.totalData
                    fSetPaginationOptions(totalData, index)
                }
                
                closeModal()
            }
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    const checkResponse = (response) => {
        if(response.status === ApiResponseSuccess){
            return true
        }else if(response.status === ApiResponseStatusUnauthorized){
            window.location.href = "/login"
        }else{
            openModal(ModalTypeFail, { message: response.message })
            return false
        }
    }

    useEffect(() => {
        if (firstLoad) {
            openModal(ModalTypeLoading)
        }

        fBindGrid(0).then(() => {
            closeModal()
            setFirstLaod(false)
        })
    },[companyName, status])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <div >
                <span className="font-semibold text-2xl">Client</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Client Name</span>
                        <input className="input" value={companyName} onChange={(e) => { setCompanyName(e.target.value) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[120px]">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <button className="button flex gap-2" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
            </div>
           
            <div className="mt-2 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Client Name</th>
                            <th className="font-semibold text-left px-2">Location Quota</th>
                            <th className="font-semibold text-left px-2">Price per location</th>
                            <th className="font-semibold text-left px-2">Monthly Price</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { companyList?.data?.listData?.length === 0 && (
                            <tr className="text-center h-12">
                               <td colSpan={8}>No Data Available</td> 
                            </tr>
                        )}
                        { companyList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.companyName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.locationQuota } Location</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.pricePerLocation) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(parseInt(data.locationQuota) * parseFloat(data.pricePerLocation)) }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button gap-2 flex" onClick={() => editBtnClick(data.companyId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2`} onClick={() => deleteBtnClick(data.companyId, data.status)}>
                                            {data.status === StatusCodeActive ? (<TrashIcon className="w-4 fill-white" />) : (<RevisionIcon className="w-4 fill-white" />)}
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />
        </div>
    )
}